import { EnvelopeOpenIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

/** Compact mail row for the Moduler tab — no body excerpt. */
export function CaseEmailExcerptCard({ comm, onOpenThread, onOpenMessage }) {
  const { t } = useTranslation();
  if (!comm?.id) return null;
  const isInbound = comm.direction === "inbound";
  const sent = comm.sent_at ? new Date(comm.sent_at).toLocaleString("nb-NO") : null;

  const open = () => {
    if (comm.graph_message_id && onOpenMessage) onOpenMessage(comm);
    else onOpenThread?.(comm);
  };

  return (
    <button
      type="button"
      className="cv-mail-chip w-full max-w-full text-left"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        open();
      }}
    >
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-50 text-slate-700">
        <EnvelopeOpenIcon className="h-4 w-4" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-[11px] font-semibold uppercase tracking-wide text-slate-500">
          {`${t("E-post")} · ${isInbound ? t("inbound") : t("outbound")}`}
        </span>
        <span className="cv-mail-chip-label mt-0.5 block">{comm.subject || t("E-post")}</span>
        {sent ? <span className="mt-0.5 block text-[11px] text-slate-500">{sent}</span> : null}
      </span>
      <span className="shrink-0 text-xs font-semibold text-[#0F55B8]">
        {t("case.mail_thread.open")}
      </span>
    </button>
  );
}
